export const zipCodeSearchResponse = [
  {
    name: 'PARIS',
    insee: '75120',
  },
];

export const multipleZipCodeSearchResponse = [
  {
    name: 'PARIS',
    insee: '75120',
  },
  {
    name: 'LYON',
    insee: '69000',
  },
  {
    name: 'MARSEILLE',
    insee: '13000',
  },
  {
    name: 'GERIENFE',
    insee: '69000',
  },
  {
    name: 'IVRY SUR SEINE',
    insee: '94200',
  },
  {
    name: 'TOULOUSE',
    insee: '31000',
  },
  {
    name: 'NICE',
    insee: '06000',
  },
  {
    name: 'NANTES',
    insee: '44000',
  },
  {
    name: 'STRASBOURG',
    insee: '67000',
  },
  {
    name: 'MONTPELLIER',
    insee: '34000',
  },
  {
    name: 'BORDEAUX',
    insee: '33000',
  },
  {
    name: 'LILLE',
    insee: '59000',
  },
  {
    name: 'RENNES',
    insee: '35000',
  },
  {
    name: 'REIMS',
    insee: '51100',
  },
  {
    name: 'LE HAVRE',
    insee: '76600',
  },
  {
    name: 'SAINT-ÉTIENNE',
    insee: '42000',
  },
  {
    name: 'TOULON',
    insee: '83000',
  },
  {
    name: 'GRENOBLE',
    insee: '38000',
  },
  {
    name: 'DIJON',
    insee: '21000',
  },
  {
    name: 'ANGERS',
    insee: '49000',
  },
  {
    name: 'NÎMES',
    insee: '30000',
  },
  {
    name: 'VILLEURBANNE',
    insee: '69100',
  },
];
